export const SHADOW_DEFINITIONS = {
    bottom: {
        level1: "0px 2px 2px rgba(31, 43, 61, 0.12)",
        level2: "0px 8px 12px rgba(31, 43, 61, 0.04)",
    },
    top: {
        level1: "0px -2px 10px rgba(31, 43, 61, 0.12)",
        level2: "0px -4px 10px rgba(0, 0, 0, 0.16)",
    },
    left: {
        level1: "-4px -4px 5px 0px rgba(31, 43, 61, 0.12)",
        level2: "-4px -4px 5px 0px rgba(31, 43, 61, 0.12)",
    },
    right: {
        level1: "4px 4px 5px 0px rgba(31, 43, 61, 0.12)",
        level2: "4px 4px 5px 0px rgba(31, 43, 61, 0.12)",
    },
    border: {
        allAround: "-2px -2px 18px rgba(31, 43, 61, 0.04)",
        tooltip: "0px 4px 8px rgba(31, 43, 61, 0.04)",
    },
};
//# sourceMappingURL=shadows.js.map